
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.18 10.38a2.8 2.8 0 01-1.98.82h-7a2.1 2.1 0 00-1.505.595l-2.1 2.1a.344.344 0 01-.492.003A.35.35 0 010 13.65V2.8A2.8 2.8 0 012.8 0h8.4A2.8 2.8 0 0114 2.8v5.6a2.8 2.8 0 01-.82 1.98zM8.898 7.33l-.295.296a.209.209 0 01-.296 0l-.812-.813-.813-.812-1.625 1.625a.209.209 0 01-.295 0l-.296-.296a.209.209 0 010-.295L6.091 5.41 4.466 3.785s-.06-.093-.06-.148c0-.055.021-.108.06-.148l.296-.295a.209.209 0 01.295 0l1.625 1.625 1.625-1.625a.209.209 0 01.296 0l.295.295a.209.209 0 010 .296L7.273 5.41l1.625 1.625a.209.209 0 010 .295z"}})])
          )
        }
      }
    